/**
 * ...
 * @author Robert Lombardo, Wakefield Studios ( rob@wakefield-studios.com )
 */
const YesNoNode = require('../YesNoNode');
const TreeNode = require('../TreeNode');
const BattleCalc = require('../../BattleCalc');
const Q_target_high_hp = require('./Q_target_high_hp');

const Q_better_to_melee = function (actor, battleState) {
  const node = new YesNoNode(actor, battleState);

  node.branches[node.YES] = new TreeNode(null, null);
  node.branches[node.NO] = new Q_target_high_hp(actor, battleState);

  node.yesNoEvalFunction = function (target) {
    if (
      BattleCalc.adjacent(target, this.actor) &&
      !BattleCalc.getEquippedAbility(actor, 'void_spike') &&
      !BattleCalc.getEquippedAbility(actor, 'infect_mind') &&
      !BattleCalc.getEquippedAbility(actor, 'lightning') &&
      !BattleCalc.getEquippedAbility(actor, 'fumigate') &&
      !BattleCalc.getEquippedAbility(actor, 'molotov_cocktail') &&
      !BattleCalc.getEquippedAbility(actor, 'arrow_shot') &&
      !BattleCalc.getEquippedAbility(actor, 'razor_shot')
    ) {
      return true;
    }

    return false;
  };

  return node;
};
module.exports = Q_better_to_melee;
